import React, { useState, useRef, useEffect } from "react";
import DataTable from "react-data-table-component";
import { endPoints } from "../../constant/Environment";
import { getAllData } from "../../Utility/API";

import FilterComponent from "../../components/FilterComponent";
const columns = [
  {
    name: "Id",
    selector: (row) => row.idUser,
    sortable: true,
  },
  {
    name: "Type",
    selector: (row) => row.login,
    sortable: true,
  },
  {
    name: "N°E",
    selector: (row) => row.email,
    sortable: true,
  },
  {
    name: "Player",
    selector: (row) => row.name,
    sortable: true,
  },
  {
    name: "Agent",
    selector: (row) => row.surname,
    sortable: true,
  },
  {
    name: "Operator",
    selector: (row) => row.sex,
    sortable: true,
  },
  {
    name: "Insert at",
    selector: (row) => row.birthDate,
    sortable: true,
  },
  {
    name: "Amount",
    selector: (row) => row.mobile,
    sortable: true,
  },
  {
    name: "Poten.Win",
    selector: (row) => row.town,
    sortable: true,
  },
  {
    name: "Expire at",
    selector: (row) => row.country,
    sortable: true,
  },
  {
    name: "Status",
    selector: (row) => row.insertionTime,
    sortable: true,
  },
  {
    name: "Result",
    selector: (row) => row.bankIban,
    sortable: true,
  },
  {
    name: "Notes",
    selector: (row) => row.year,
    sortable: true,
  },
  {
    name: "Options",
    selector: (row) => row.year,
    sortable: true,
  },
];


const DefineResults = () => {
  const [pending, setPending] = useState(true);
  const [rows, setRows] = useState([]);

  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);
  const filteredItems = rows.filter(
    (item) =>
      item.name && item.name.toLowerCase().includes(filterText.toLowerCase())
  );

  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    let url = `${endPoints.api.GET_USERS}`;
    await getAllData(url)
      .then((response) => {
        console.log("data", response.status);
        if (response.status === "success") {
          setRows(response.data);
          setPending(false);
        } else {
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <>
      <div className="main">
        <div id="Sportbook">
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <div className="row">
                <div className="col-md-12">
                  <h2 className="mb-4">Define Results</h2>
                </div>
              </div>
              <div
                className="row"
                style={{ backgroundColor: "#fff", padding: "5px 0px 20px 0px" }}
              >
                <DataTable
                  title="MATCH LIST"
                  columns={columns}
                  // data={rows}
                  progressPending={pending}
                  pagination
                  fixedHeader={true}
                  fixedHeaderScrollHeight={"400px"}
                  data={filteredItems}
                  paginationResetDefaultPage={resetPaginationToggle} // optionally, a hook to reset pagination to page 1
                  subHeader
                  subHeaderComponent={subHeaderComponentMemo}
                />

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DefineResults;
